import {
  initialCreateListeBiancheData,
  initialListeBiancheData,
  initialSelectedListeBianche,
} from "./helper";
import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";

const initialState = {
  listeBiancheData: initialListeBiancheData,
  createListeBiancheData: initialCreateListeBiancheData,
  createUpdateDeleteListeBiancheLoading: false,
  selectedListeBianche: initialSelectedListeBianche,
  exportLoading: false,
};

const setListeBiancheData = (state, action) => {
  return updateObject(state, {
    listeBiancheData: updateObject(state.listeBiancheData, {
      [action.key]: action.value,
    }),
  });
};

const setCreateListeBiancheData = (state, action) => {
  return updateObject(state, {
    createListeBiancheData: updateObject(state.createListeBiancheData, {
      [action.key]: action.value,
    }),
  });
};

const setSelectedListeBianche = (state, action) => {
  return updateObject(state, {
    selectedListeBianche: updateObject(state.selectedListeBianche, {
      [action.key]: action.value,
    }),
  });
};

const setCreateUpdateDeleteListeBiancheLoading = (state, action) => {
  return updateObject(state, {
    createUpdateDeleteListeBiancheLoading: action.value,
  });
};

const setListeBiancheExportLoading = (state, action) => {
  return updateObject(state, {
    exportLoading: action.value,
  });
};

const listeBiancheReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LISTE_BIANCHE_DATA:
      return setListeBiancheData(state, action);
    case actionTypes.EXPORT_LISTE_BIANCHE_LOADING:
      return setListeBiancheExportLoading(state, action);
    case actionTypes.GET_LISTE_BIANCHE:
      return setSelectedListeBianche(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_LISTE_BIANCHE:
      return setCreateUpdateDeleteListeBiancheLoading(state, action);
    case actionTypes.CREATE_LISTE_BIANCHE_DATA:
      return setCreateListeBiancheData(state, action);
    default:
      return state;
  }
};

export default listeBiancheReducer;
